import { render, staticRenderFns } from "./LegalDocumentCertifications.vue?vue&type=template&id=7c4fac1b&scoped=true&"
import script from "./LegalDocumentCertifications.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentCertifications.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentCertifications.vue?vue&type=style&index=0&id=7c4fac1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4fac1b",
  null
  
)

export default component.exports